import React from 'react';
import { bool, object } from 'prop-types';

import HighlightOptions from './HighlightOptions';
import AddNoteOption from './AddNoteOption';
import EditNoteOptions from './EditNoteOptions';
import NoteEditor from 'Shared/NoteEditor';


const Fragment = React.Fragment;
const MainSlatViews = ({ container, isNoteEditorOpen, onKeyDown, selectedHighlight, styles }) => {
  const { noteText } = selectedHighlight;

  function defaultDisplay() {
    return (
      <Fragment>
        <HighlightOptions />

        { !noteText
          ? <AddNoteOption />
          : <EditNoteOptions />
        }
      </Fragment>
    );
  }

  function displayNoteEditor() {
    return <NoteEditor />;
  }

  return (
    <div className={ container } style={ styles } onKeyDown={ onKeyDown } tabIndex="-1">
      { !isNoteEditorOpen
        ? defaultDisplay()
        : displayNoteEditor()
      }
    </div>
  );
};

MainSlatViews.propTypes = {
  isNoteEditorOpen: bool,
  selectedHighlight: object,
  styles: object
};


export default MainSlatViews;
